export default function coursesLoadMore() {
  const components = Array.from(
    document.querySelectorAll("[data-courses-load-more]")
  );
  if (!components.length) return;

  for (const root of components) {
    const batchSize = Math.max(
      1,
      Number.parseInt(root.getAttribute("data-batch-size") || "9", 10) || 9
    );

    const items = Array.from(root.querySelectorAll(".course"));
    const button = root.querySelector(
      ".courses--load-more-button, .courses__load-more-button"
    );

    if (!button || items.length <= batchSize) {
      if (button) button.hidden = true;
      continue;
    }

    let visibleCount = 0;

    const apply = () => {
      items.forEach((el, idx) => {
        el.hidden = idx >= visibleCount;
      });

      button.hidden = visibleCount >= items.length;
    };

    const showNext = () => {
      visibleCount = Math.min(items.length, visibleCount + batchSize);
      apply();
    };

    // Initial state
    visibleCount = batchSize;
    button.hidden = false;
    apply();

    button.addEventListener("click", showNext);
  }
}
